import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Popover, Tooltip } from 'antd';

export const StyledLabel = ({ children, ...props }) => {
  return (
    <label style={{ fontWeight: 'bold' }} {...props}>
      {children}
    </label>
  );
};

export function ButtonContainer(props) {
  const { noSpace } = props;
  return (
    <div
      style={props.style}
      className={`styled-form-btn-container-comp ${props.className} ${
        noSpace && 'no-space'
      }`}
    >
      {props.children}
    </div>
  );
}

ButtonContainer.propTypes = {
  noSpace: PropTypes.bool,
};

export function InputContainer(props) {
  return (
    <div className={`styled-form-input-container-comp ${props.className}`}>
      {props.children}
    </div>
  );
}

export function StyledModal(props) {
  const hasTitle = typeof props.title !== 'undefined' && props.title !== null;
  const modalInstanceClassName = useMemo(() => {
    return `styled-modal-instance-${Math.random().toString(36).slice(2, 10)}`;
  }, []);
  const rootClassName = [props.rootClassName, modalInstanceClassName]
    .filter(Boolean)
    .join(' ');

  const handleAfterOpenChange = (open) => {
    if (open) {
      requestAnimationFrame(() => {
        const modalRoot = document.querySelector(`.${modalInstanceClassName}`);
        const closeButton = modalRoot?.querySelector('.ant-modal-close');

        if (closeButton && document.activeElement === closeButton) {
          closeButton.blur();
        }
      });
    }

    if (props.afterOpenChange) {
      props.afterOpenChange(open);
    }
  };

  return (
    <Modal
      contentClassName={`styled-modal-content-comp ${props.className}`}
      style={props.style}
      {...props}
      rootClassName={rootClassName}
      afterOpenChange={handleAfterOpenChange}
      title={
        hasTitle ? (
          <StyledModalHeader {...props}>{props.title}</StyledModalHeader>
        ) : (
          props.title
        )
      }
    />
  );
}

export function StyledPopover(props) {
  return (
    <Popover
      popperClassName={`styled-popover-content-comp ${props.className}`}
      style={props.style}
      {...props}
    />
  );
}

export function StyledModalHeader(props) {
  return (
    <div
      {...props}
      className={`styled-modal-header-comp second-title title ${props.className} ${
        !props.children ? 'without-children' : ''
      }`}
    >
      {props.children}
    </div>
  );
}

StyledModalHeader.propTypes = {
  toggle: PropTypes.func, // ak sa posle zobrazi sa X
};

export function SimpleSwitch(props) {
  const active = props.active ? 'active' : '';
  return (
    <div
      onClick={props.onClick}
      className={`styled-listing-check-box-comp ${active}`}
    >
      <div className="icon-wrapper">
        <i
          className={(props.icon && props.icon) || 'fa fa-check'}
          aria-hidden="true"
        />
      </div>
      <div className="text-wrapper">{props.title}</div>
    </div>
  );
}

SimpleSwitch.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  active: PropTypes.bool,
};

export function PicturePicker(props) {
  const active = props.active ? 'active' : '';
  return (
    <div
      onClick={props.onClick}
      className={`picture-choose-comp-container ${active}`}
    >
      <i className="fas fa-check" />
      <img src={props.url} alt={props.altTitle} />
    </div>
  );
}

PicturePicker.propTypes = {
  onClick: PropTypes.func,
  url: PropTypes.string.isRequired,
  altTitle: PropTypes.string,
  active: PropTypes.bool,
};

export const MainButton = (props) => {
  // React ant button
  const { hoverVisible = false, hoverText, ...buttonProps } = props;
  return (
    <Tooltip title={hoverVisible ? hoverText : ''}>
      <Button type="primary" size="large" {...buttonProps} />
    </Tooltip>
  );
};

MainButton.propTypes = {
  unelevated: PropTypes.bool,
  outlined: PropTypes.bool,
  dense: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.any,
  href: PropTypes.string,
  trailingIcon: PropTypes.any,
  hoverVisible: PropTypes.bool,
  hoverText: PropTypes.string,
};

// Formik
export { default as RadioButtonsPicker } from './formikFields/RadioButtonsPicker/RadioButtonsPicker';

//Basic
export { default as SubmitButton } from './basicFields/SubmitButton/SubmitButton';
export { default as BasicTextField } from './basicFields/SimpleTextInput/SimpleTextInput';
export { default as YearsPicker } from './basicFields/YearsPicker/YearsPicker';
export { default as CaptchaValidation } from './basicFields/captcha/CaptchaValidation';
export { default as SimpleDatePicker } from './basicFields/SimpleDatePicker/SimpleDatePicker';
export { default as SimpleDateTimePicker } from './basicFields/SimpleDateTimePicker/SimpleDateTimePicker';
export { default as SimpleSelectSearch } from './basicFields/SimpleSelectSearch/SimpleSelectSearch';
export { default as RangeDatePicker } from './basicFields/RangeDatePicker/RangeDatePicker';
export { default as ErrorMessage } from './basicFields/ErrorMessage/ErrorMessage';
export { default as SimpleTimePicker } from './basicFields/SimpleTimePicker/SimpleTimePicker';
export { default as StudyProgramPicker } from './basicFields/StudyProgramPicker/StudyProgramPicker';
